import { FileUploadData, useFileUpload } from '@/hooks/upload/FileUpload';
import { ApplicationState } from '@/store';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { TypeAccepted } from '..';

interface Props {
    typeAccepted: TypeAccepted;
    onStart?: () => void;
    onComplete?: (response: FileUploadData) => void;
    customFolder?: string;
    disabled?: boolean;
}

const MassImportUpload: React.FC<Props> = ({ typeAccepted, onStart, onComplete, customFolder, disabled = false }: Props) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);

    const { acceptConfiguration, selectFileHandler } = useFileUpload({
        typeAccepted,
        inputRef,
        customFolder,
    });

    const buttonSelectFile = (e: any) => {
        if (inputRef.current) {
            inputRef.current.click();
        }
        e.preventDefault();
    };

    const cleanFile = () => {
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    };

    const disabledClass: string = disabled ? 'disabled' : '';

    return (
        <>
            <input
                accept={acceptConfiguration.accept}
                disabled={disabled}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => selectFileHandler(e, onStart, onComplete)}
                onClick={cleanFile}
                ref={inputRef}
                style={{ display: 'none' }}
                type="file"
            />
            <button className={`dropdown-item pt-3 pb-3 ${disabledClass}`} onClick={buttonSelectFile} type="button">
                <i className="material-icons-outlined va-t mr-1">unarchive</i>
                {strings.massImport.CHOSE_FILE}
            </button>
        </>
    );
};

export default MassImportUpload;
